/**
 * The unified production-record input's URL contract (PROD-1279).
 *
 * The Production Records page fills a day ONE way: a day card's action opens
 * `?task=record&day=yyyy-mm-dd[&mealtime=LUNCH]`, the screen that mirrors the
 * printed record (every mealtime a wizard step, one table per step whose
 * columns are the record's own). The `Spreadsheet mode` switch that used to
 * route a card to the two shipped one-step tasks instead is gone (Abner,
 * 2026-09-18: "we're sticking to the spreadsheet mode"), and so is the
 * per-browser opt-out it stored; the legacy `?task=transport-logs|
 * service-records` deep links the Tasks inbox still emits are rewritten to
 * `?task=record` by the page. The two one-step flows stay reachable only from
 * the record detail page (complete / amend). The snapshot directories under
 * `docs/abner-workspace/production-records/snapshots/` remain the way back.
 *
 * Pure — no React, no fetch. Unit-tested in
 * `client/test/lib/production-records/spreadsheet-model.test.ts`.
 */

/** The `?task=` value the unified input answers to. */
export const RECORD_TASK_PARAM = 'record'

/**
 * `?task=record` → `'record'`, anything else → null.
 *
 * Deliberately separate from `parseDayTaskParam`: that function answers "which
 * of the two shipped tasks is this", and widening its union would make every
 * `DayTaskKind` switch in the dialog and the timeline incomplete. The unified
 * input is a THIRD thing the page resolves before them (and now redirects them
 * to), so removing it is removing this function and its one call site.
 */
export function parseRecordTaskParam(raw: string | null | undefined): 'record' | null {
  return raw === RECORD_TASK_PARAM ? RECORD_TASK_PARAM : null
}
